import { Input, Component } from '@angular/core';
import { IDynamicallyCreatedComponent } from '../../core-data-model/DynamicallyCreated.component';
import { OldIconConfig } from './OldIconConfig';

@Component({
    selector: 'old-icon',
    template: `
        @if (properties.src) {
            <img
                [src]="getSource()"
                [ngClass]="getClasses()"
                (mouseenter)="mouseEnter()"
                (mouseleave)="mouseLeave()"
            />
        } @else {
            <i
                [ngClass]="getClasses()"
                (mouseenter)="mouseEnter()"
                (mouseleave)="mouseLeave()"
            >
            </i>
        }
        <!-- NOTE: Added to Support browsers where Null source breaks the img -->
    `,
    standalone: false
})
export class OldIconComponent implements IDynamicallyCreatedComponent {
    @Input()
    properties: OldIconConfig;

    isHovered = false;

    mouseEnter() {
        this.isHovered = true;
    }
    mouseLeave() {
        this.isHovered = false;
    }

    getSource(): string {
        return this.isHovered && this.properties.hoveredSrc
            ? this.properties.hoveredSrc
            : this.properties.src || '';
    }

    getClasses() {
        const iconClass = this.properties.isIconMoon ? 'ico-moon ' : 'fa ';
        return this.isHovered && this.properties.hoveredCssClass
            ? iconClass + this.properties.hoveredCssClass
            : iconClass + this.properties.cssClass || iconClass;
    }
}
